export type FinanceAdjustment = {
  amount: number;
  reason: string | null;
  adjustedBy: string | null;
  adjustedAt: string;
};

const usdFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

/** Signed USD amount for a finance adjustment, e.g. "+$50.00" or "-$50.00". */
export const formatFinanceAdjustmentAmount = (amount: number | string): string => {
  const value = Number(amount) || 0;
  return `${value < 0 ? "-" : "+"}${usdFormatter.format(Math.abs(value))}`;
};

/** Amount plus optional reason, e.g. "-$50.00 (Downtime credit)" or "+$50.00". */
export const formatFinanceAdjustmentValue = (adjustment: Pick<FinanceAdjustment, "amount" | "reason">): string =>
  `${formatFinanceAdjustmentAmount(adjustment.amount)}${adjustment.reason ? ` (${adjustment.reason})` : ""}`;

/** Signed adjustment that turns `currentTotal` into `newTotal`, rounded to cents. */
export const getFinanceAdjustmentAmount = (newTotal: number, currentTotal: number): number =>
  Math.round((newTotal - currentTotal) * 100) / 100;
